const filterUndefinedFromObject = (obj) => {
  const result = Object.keys(obj).reduce((acc, propName) => {
    if (obj[propName] !== undefined) {
      return {...acc, [propName]: obj[propName]}
    }
    return acc
  }, {})

  return result
}

export const checkIfIntegrityVerified = (objct) => {
  if (
    objct.EcologicalIntegrityEcoRegionId ||
    objct.dateOfAssessment ||
    objct.evidenceForIntactEcologicalCommunities||
    objct.evidenceOfLowHumanImpact ||
    objct.numberOfCriterionSitesInEcoRegion
  ) {
    return true
  }
  return false
}


export default filterUndefinedFromObject
